import { render } from "./NewsCarousel.vue?vue&type=template&id=8ff13a22&scoped=true"
import script from "./NewsCarousel.vue?vue&type=script&lang=js"
export * from "./NewsCarousel.vue?vue&type=script&lang=js"

import "./NewsCarousel.vue?vue&type=style&index=0&id=8ff13a22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ff13a22"]])

export default __exports__